'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getComponentName(props) {
  if (props.component === "Button") {
    return props.options.text;
  }

  if (props.component === "Select" || props.component === "TextField") {
    return props.options.placeholder;
  }

  if (props.component === "Checkbox") {
    return props.options.label;
  }

  if (props.component === "SnackBar") {
    return (
      props.options.items[props.options.items.length - 1].status || "normal"
    );
  }

  return "Unknown component";
}

function getComponentValue(props) {
  if (props.component === "TextField") {
    return props.options.value;
  }

  if (props.component === "Checkbox") {
    return props.options.checked;
  }

  if (props.component === "Select") {
    return props.options.label;
  }

  return undefined;
}

function getComponentCustomParams(props) {
  const customParamsProps = props.options.props["data-analytic-params"];
  if (customParamsProps) {
    if (typeof customParamsProps === "string") {
      return JSON.parse(decodeURIComponent(customParamsProps));
    }
    return customParamsProps;
  }

  return undefined;
}

function constaEventHandler(props) {
  if (!window.gpnAnalytics) {
    console.warn(
      "Failed to send analytics event, no gpnAnalytics object found on window"
    );
    return;
  }

  const componentname = getComponentName(props);

  const componentid =
    props.component === "SnackBar"
      ? undefined
      : props.options.props["data-analytics-id"];

  const value = getComponentValue(props);
  const customparams = getComponentCustomParams(props);

  const sendObject = {
    componentid,
    constaeventtype: props.event,
    component: props.component,
    value,
    componentname,
  };

  if (customparams) {
    sendObject.customparams = customparams;
  }

  window.gpnAnalytics.sendEvent(3, sendObject);
}

exports.constaEventHandler = constaEventHandler;
//# sourceMappingURL=index.js.map
